import {WindowParam} from "../../../library/context/WindowContext";
import {ColumnUnit} from "../../../library/atomic/unit/ColumnUnit";
import {SizeAttr} from "../../../library/basic/size";
import {RowUnit} from "../../../library/atomic/unit/RowUnit";
import {appEffectiveWidth, ewSize, ewSize343} from "../themeUtil/screenWidthUtil";
import {BoxAttr, ColumnAttr, RowAttr} from "../../../library/basic/compose";
import {ImageUnit} from "../../../library/atomic/image/ImageUnit";
import {heightGap, widthGap} from "../../../library/atomic/unit/BoxUnit";
import {SpanText} from "../../../library/atomic/text/SpanText";
import {FontAttr} from "../../../library/basic/font";
import {ColorAttr} from "../../../library/basic/color";
import appIcon from "../../../assets/appshare/appIcon.png";
import {c8a8a8d} from "../themeUtil/colorUtil";
import appOpenButton from "../../../assets/appshare/appOpenButton.svg";
import browserHint from "../../../assets/appshare/browser_hint.svg";
import {isIOS, isMobile, isQQ, isWeiXinOrQQ} from "../../../library/util/userAgentUtil";
import {fetchNumberParam} from "../../../library/util/linkUtil";

function jumpApp(openBrowserHint?: () => void) {
    if (!isMobile()) {
        window.location.href = "https://coralplanets.com"
    } else {
        if (isWeiXinOrQQ()) {
            if (openBrowserHint) {
                openBrowserHint()
            }
        } else if (isIOS()) {
            window.location.href = "https://apps.apple.com/cn/app/%E7%8F%8A%E7%91%9A%E7%A4%81/id6482988054"
        } else {
            let startTime = Date.now();

            let currentPath = window.location.href
            let androidLaunchPath = "infoscheme://com.coralplanets.coralreefshare/browEntrance?"
            if (currentPath.indexOf("content") >= 0) {
                let content_id = fetchNumberParam("id")
                if (content_id > 0) {
                    window.location.href = androidLaunchPath + "type=content&entityId=" + content_id
                }
            } else if (currentPath.indexOf("activity") >= 0) {
                let activity_id = fetchNumberParam("id")
                if (activity_id > 0) {
                    window.location.href = androidLaunchPath + "type=activity&entityId=" + activity_id
                }
            } else if (currentPath.indexOf("person") >= 0) {
                let acc_id = fetchNumberParam("acc_id")
                let acc_type = fetchNumberParam("acc_type")
                let related_id = fetchNumberParam("related_id")
                if (acc_id > 0 && acc_type >= 0) {
                    window.location.href = androidLaunchPath + "type=person&accId=" + acc_id + "&accType=" + acc_type +
                        "&relatedId=" + related_id
                }
            }

            let t = setTimeout(function() {
                let endTime = Date.now();
                if (!startTime || endTime - startTime < 2800) {
                    window.location.href = "https://coralplanets.com"
                }
            }, 2500);
            window.onblur = function() {
                clearTimeout(t);
            }
        }
    }
}

export function InnerTop(wp: WindowParam, openBrowserHint?: () => void) {
    return (
        <ColumnUnit sizeAttr={new SizeAttr(wp, "100vw")}
                    customStyleAttr={{"position": "fixed", "top": "0", "zIndex": "999", "background": "white"}}>
            <RowUnit sizeAttr={new SizeAttr(wp, appEffectiveWidth(wp))}
                     colorAttr={new ColorAttr(wp, "", "white")}
                     customStyleAttr={ColumnAttr.getChildrenPositionObj()}>
                <RowUnit customStyleAttr={ColumnAttr.getChildrenPositionObj()}
                         sizeAttr={new SizeAttr(wp, ewSize343(wp), ewSize(wp, 62))}>
                    <ImageUnit customStyleAttr={RowAttr.getChildrenPositionObj()} innerImgStyle={{
                        "borderRadius": ewSize(wp, 6), "border": "1px solid #d9d9d9"
                    }}
                               url={appIcon} sizeAttr={new SizeAttr(wp, ewSize(wp, 35), ewSize(wp, 35))}/>
                    {widthGap(wp, ewSize(wp, 9))}
                    <ColumnUnit customStyleAttr={RowAttr.getChildrenPositionObj()}>
                        <SpanText fontAttr={new FontAttr(wp, ewSize(wp, 13))}>
                            信风Flow
                        </SpanText>
                        {heightGap(wp, ewSize(wp, 2))}
                        <SpanText colorAttr={c8a8a8d(wp)}
                                  fontAttr={new FontAttr(wp, ewSize(wp, 11))}>
                            大学生专属社区
                        </SpanText>
                    </ColumnUnit>

                    {/*按钮*/}
                    <RowUnit
                        onClick={() => {
                            jumpApp(openBrowserHint)
                        }}
                        customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                            "background": "#0EE3CA", "borderRadius": ewSize(wp, 14), "marginLeft": "auto"
                        })}
                        sizeAttr={new SizeAttr(wp, ewSize(wp, 74), ewSize(wp, 28))}>
                        <SpanText colorAttr={new ColorAttr(wp, "white")}
                                  fontAttr={new FontAttr(wp, ewSize(wp, 11), "550")}
                                  customStyleAttr={Object.assign(BoxAttr.getChildrenPositionObj(), {"transform": "translateY(-" + ewSize(wp, 1) + ")"})}>
                            点击打开
                        </SpanText>
                    </RowUnit>

                </RowUnit>
            </RowUnit>
            {heightGap(wp, ewSize(wp, 6))}
        </ColumnUnit>
    )
}

export function InnerAppOpenButton(wp: WindowParam, yOffset?: number, openBrowserHint?: () => void) {
    let c = 78;
    if (yOffset) c = yOffset

    return (
        <ColumnUnit sizeAttr={new SizeAttr(wp, "100vw")}
                    customStyleAttr={{"position": "fixed", "bottom": "0", "zIndex": "999"}}>
            <ImageUnit
                onClick={() => {
                    jumpApp(openBrowserHint)
                }}
                customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {"transform": "translateY(-" + ewSize(wp, c) + ")"})}
                url={appOpenButton} sizeAttr={new SizeAttr(wp, ewSize(wp, 155))}/>
        </ColumnUnit>
    )
}

export function BrowserOpenHint(wp: WindowParam, hideHint: () => void) {
    return (
        <ColumnUnit
            onClick={() => {
                hideHint()
            }}
            sizeAttr={new SizeAttr(wp, "100vw", "100vh")}
            colorAttr={new ColorAttr(wp, "", "#000000a0")}
            customStyleAttr={{"position": "fixed", "top": "0", "zIndex": "9999"}}>

            {/*提示浏览器打开图片*/}
            <RowUnit sizeAttr={new SizeAttr(wp, appEffectiveWidth(wp))}
                     colorAttr={new ColorAttr(wp, "", "")}
                     customStyleAttr={ColumnAttr.getChildrenPositionObj()}>
                <ImageUnit
                    customStyleAttr={{"marginLeft": "auto", "zIndex": "9999", "marginTop": ewSize(wp, 7), "marginRight": ewSize(wp, 16)}}
                    url={isQQ() ? browserHint : browserHint} sizeAttr={new SizeAttr(wp, ewSize(wp, 182))}/>
            </RowUnit>

        </ColumnUnit>
    )
}